import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Layout from './Layout';
import PdfGenerator from './PdfGenerator';
import DOMPurify from 'dompurify';
import Dates from './Dates';
import Loading from './Loading';

import { useNumberFormat } from '@react-input/number-format';

const Forms = () => {
  const [loading, setLoading] = useState(false);
  const [searchRuc, setSearchRuc] = useState(false);
  const [isClient, setIsClient] = useState(false);
  const [preview, setPreview] = useState(null);
  const [previewDni, setPreviewDni] = useState(null);
  const [uploadDocument, setUploadDocument] = useState(false);
  const [ruc, setRuc] = useState('');
  const [fileUpload, setFileUpload] = useState(null);
  const [dnifile, setDni] = useState(null);
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    razonSocial: '',
    nombreComercial: '',
    direccion: '',
    telefonos: '',
    paginaWeb: '',
    email: '',
    direccionCorrespondencia: '',
    public_reg: '',
    anniversary_date: '',
    ruc: 0,
    last_name_1: '',
    names_1: '',
    charge_1: '',
    otherCharge_1: '',
    email_1: '',
    phone_1: '',
    birthday_1: '',
    representative_1: true,
    // whatsapp_1: false,
    last_name_2: '',
    names_2: '',
    charge_2: '',
    otherCharge_2: '',
    email_2: '',
    phone_2: '',
    birthday_2: '',
    representative_2: false,
    // whatsapp_2: false,
    last_name_3: '',
    names_3: '',
    charge_3: '',
    otherCharge_3: '',
    email_3: '',
    phone_3: '',
    birthday_3: '',
    representative_3: false,
    // whatsapp_3: false,
    last_name_4: '',
    names_4: '',
    charge_4: '',
    otherCharge_4: '',
    email_4: '',
    phone_4: '',
    birthday_4: '',
    representative_4: false,
    // whatsapp_4: false,
    economic_section: '',
    description: '',
    number_employees: 0,
    heritage: 0,
    anual_sale: 0,
    authorization_person: '',
    authorization_person_charge: '',
  });

  const inputRef = useNumberFormat({
    locales: 'en',
    maximumFractionDigits: 2,
  });

  const cargos = [
    'ADMINISTRADOR',
    'ASISTENTE DE GERENCIA',
    'CEO',
    'CONTABILIDAD',
    'DIRECTOR',
    'GERENTE GENERAL',
    'JEFE DE MARKETING',
    'JEFE DE OPERACIONES',
    'JEFE DE RECURSOS HUMANOS',
    'JEFE DE VENTAS',
    'PRESIDENCIA',
    'REPRESENTANTE LEGAL',
    'SECRETARIA',
    'OTRO',
  ];

  useEffect(() => {
    const emailFields = ['email', 'email_1', 'email_2', 'email_3', 'email_4'];
    const newErrors = { ...errors };

    emailFields.forEach((field) => {
      const value = formData[field];
      if (value && !value.includes('@')) {
        newErrors[field] = 'Formato inválido';
      } else {
        if (newErrors[field] === 'Formato inválido') {
          delete newErrors[field];
        }
      }
    });

    setErrors(newErrors);
  }, [
    formData.email,
    formData.email_1,
    formData.email_2,
    formData.email_3,
    formData.email_4,
  ]);

  const sanitizeInput = (input) => {
    return DOMPurify.sanitize(input);
  };

  const handleRucChange = (e) => {
    const sanitizedValue = sanitizeInput(e.target.value);
    setRuc(sanitizedValue);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    const lowerCaseFields = [
      'paginaWeb',
      'email',
      'email_1',
      'email_2',
      'email_3',
      'email_4',
    ];

    if (name === 'public_reg') {
      const regex = /^[0-9-]*$/;
      if (!regex.test(value)) return;
    }

    if (name === 'description') {
      const wordCount = value.trim().split(/\s+/).filter(Boolean).length;
      if (wordCount > 20) return; // No actualices si supera las 20 palabras
    }

    const processedValue = lowerCaseFields.includes(name)
      ? sanitizeInput(value.toLowerCase())
      : sanitizeInput(value.toUpperCase());

    setFormData({
      ...formData,
      [name]: processedValue,
    });
  };

  const handleFileChange = (e) => {
    const filePdf = e.target.files[0];
    setFileUpload(filePdf);

    console.log({ filePdf });

    if (filePdf) {
      if (filePdf && filePdf.type.startsWith('image/')) {
        const reader = new FileReader();
        reader.onloadend = () => {
          setPreview(reader.result);
        };
        reader.readAsDataURL(filePdf);
      } else {
        setPreview('non-image');
      }
    } else {
      setPreviewDni(null);
    }
  };

  const handleDniChange = (e) => {
    const dnifile = e.target.files[0];
    setDni(dnifile);

    if (dnifile) {
      if (dnifile.type.startsWith('image/')) {
        const reader = new FileReader();
        reader.onloadend = () => {
          setPreviewDni(reader.result);
        };
        reader.readAsDataURL(dnifile);
      } else {
        setPreviewDni('non-image');
      }
    } else {
      setPreviewDni(null);
    }
  };

  const verificarCliente = async (rucNumber) => {
    const api = process.env.REACT_APP_API_URL;
    const cliente = await axios.get(
      `${api}?documento=eq.${rucNumber}&select=id`,
      {
        headers: {
          'Accept-Charset': 'UTF-8',
          apikey: process.env.REACT_APP_SUPABASE_API_KEY,
          Authorization: 'Bearer ' + process.env.REACT_APP_SUPABASE_AUTH_TOKEN,
        },
      }
    );
    if (!(cliente.data.length > 0)) {
      return false;
    }
    return true;
  };

  const handleConsultarRuc = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      // const token = process.env.REACT_APP_SUNAT_TOKEN;
      // const response = await axios.post(
      //   'ingreso.asociados.camara-arequipa.org.pe/php/search_ruc.php',
      //   {
      //     ruc,
      //   },
      //   {
      //     headers: {
      //       'Content-Type': 'application/json',
      //     },
      //   }
      // );

      const formData = new FormData();
      formData.append('numero', ruc);

      const resp = await fetch(
        'https://ingreso.asociados.camara-arequipa.org.pe/php/search_ruc.php',
        {
          method: 'POST',
          body: formData,
        }
      )
        .then((response) => response.json())
        .then((data) => {
          const res = JSON.parse(data);
          if (!res) {
            alert(
              'El RUC ingresado no es válido o no se encontró en la SUNAT.'
            );
            return;
          }
          return res;
        })
        .catch((error) => {
          console.error('Error al consultar el RUC:', error);
          alert(
            'Hubo un error al consultar el RUC. Por favor, verifica el RUC o inténtalo más tarde.'
          );
        });
      setSearchRuc(true);
      setIsClient(await verificarCliente(ruc.trim()));
      setFormData((prevFormData) => ({
        ...prevFormData,
        razonSocial: resp.razon_social || '',
        nombreComercial: resp.razon_social || '',
        direccion:
          resp.direccion +
            ' - ' +
            resp.departamento +
            ' - ' +
            resp.provincia +
            ' - ' +
            resp.distrito || '',
        direccionCorrespondencia:
          resp.direccion +
            ' - ' +
            resp.departamento +
            ' - ' +
            resp.provincia +
            ' - ' +
            resp.distrito || '',
      }));
    } catch (error) {
      console.error('Error al consultar el RUC:', error);
      alert(
        'Hubo un error al consultar el RUC. Por favor, verifica el RUC o inténtalo más tarde.'
      );
    } finally {
      setLoading(false);
    }
  };

  const validateFields = () => {
    const newErrors = {};
    if (ruc.startsWith('2') && !formData.public_reg)
      newErrors.public_reg = true;
    if (!ruc) newErrors.ruc = true;
    if (!formData.razonSocial) newErrors.razonSocial = true;
    if (!formData.nombreComercial) newErrors.nombreComercial = true;
    if (!formData.direccion) newErrors.direccion = true;
    if (!formData.telefonos) newErrors.telefonos = true;
    if (!formData.email) newErrors.email = true;
    if (!formData.direccionCorrespondencia)
      newErrors.direccionCorrespondencia = true;
    if (!formData.last_name_1) newErrors.last_name_1 = true;
    if (!formData.names_1) newErrors.names_1 = true;
    if (!formData.charge_1) newErrors.charge_1 = true;
    if (!formData.email_1) newErrors.email_1 = true;
    if (!formData.phone_1) newErrors.phone_1 = true;
    if (formData.charge_1 === 'OTRO' && !formData.otherCharge_1)
      newErrors.otherCharge_1 = true;
    if (formData.charge_2 === 'OTRO' && !formData.otherCharge_2)
      newErrors.otherCharge_2 = true;
    if (formData.charge_3 === 'OTRO' && !formData.otherCharge_3)
      newErrors.otherCharge_3 = true;
    if (formData.charge_4 === 'OTRO' && !formData.otherCharge_4)
      newErrors.otherCharge_4 = true;
    if (!formData.economic_section) newErrors.economic_section = true;
    if (!formData.description) newErrors.description = true;
    if (!formData.authorization_person) newErrors.authorization_person = true;
    if (!formData.authorization_person_charge)
      newErrors.authorization_person_charge = true;

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleDownload = (e) => {
    e.preventDefault();
    if (validateFields()) {
      const finalFormData = {
        ...formData,
        charge_1:
          formData.charge_1 === 'OTRO'
            ? formData.otherCharge_1
            : formData.charge_1,
        charge_2:
          formData.charge_2 === 'OTRO'
            ? formData.otherCharge_2
            : formData.charge_2,
        charge_3:
          formData.charge_3 === 'OTRO'
            ? formData.otherCharge_3
            : formData.charge_3,
        charge_4:
          formData.charge_4 === 'OTRO'
            ? formData.otherCharge_4
            : formData.charge_4,
      };
      const pdfGenerator = new PdfGenerator(finalFormData, ruc);
      pdfGenerator.downloadPdf();
      setUploadDocument(true);
    } else {
      alert('Por favor, complete todos los campos requeridos.');
    }
  };

  const transformData = (data) => {
    const result = [];
    // let id = 0;

    for (let i = 0; i <= 3; i++) {
      let whatsapp = false;
      const nuevoCargo =
        data[`charge_${i + 1}`] === 'OTRO'
          ? data[`otherCharge_${i + 1}`]
          : data[`charge_${i + 1}`];
      const nombre = `${data[`names_${i + 1}`]} ${
        data[`last_name_${i + 1}`]
      }`.trim();
      const cargo = nuevoCargo || '';
      const email = data[`email_${i + 1}`] || '';
      const representante = data[`representative_${i + 1}`] || false;
      const onomastico = data[`birthday_${i + 1}`] || '';
      const telefono = data[`phone_${i + 1}`] || '';

      if (`names_${i + 1}` === 'names_1') {
        whatsapp = true;
      }

      if (!nombre.trim() && !cargo && !email) continue;

      result.push({
        // id,
        nombre,
        cargo,
        email,
        telefono,
        representante,
        whatsapp,
        onomastico,
      });

      // id++;
    }

    return result;
  };

  useEffect(() => {
    if (ruc.startsWith('2') && !formData.public_reg) {
      setErrors((prev) => ({ ...prev, public_reg: true }));
    } else {
      setErrors((prev) => {
        const newErrors = { ...prev };
        delete newErrors.public_reg;
        return newErrors;
      });
    }
  }, [ruc, formData.public_reg]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!fileUpload) {
      alert('Por favor, adjunte un archivo PDF.');
      return;
    }

    if (!dnifile) {
      alert('Por favor, adjunte su DNI.');
      return;
    }

    setLoading(true);

    const date = new Date();
    const dateString = date.toISOString().replace(/:/g, '_');
    const nameFile = ruc + '_' + dateString;
    const nameDniFile = 'dni_' + ruc + '_' + dateString;

    const formDataToSend = new FormData();
    formDataToSend.append('pdf', fileUpload);
    formDataToSend.append('dni', dnifile);
    formDataToSend.append('nameDni', nameDniFile);
    formDataToSend.append('nameFile', nameFile);

    // CONECTIVIDAD CON BASE DE DATOS

    const API_URL = process.env.REACT_APP_RPC_URL;
    const HEADERS = {
      apikey: process.env.REACT_APP_SUPABASE_API_KEY,
      Authorization: `Bearer ${process.env.REACT_APP_SUPABASE_AUTH_TOKEN}`,
      'Content-Type': 'application/json',
    };

    const sanitizedData = {
      razon_social: sanitizeInput(formData.razonSocial),
      razon_comercial: sanitizeInput(formData.nombreComercial),
      direccion_fiscal: sanitizeInput(formData.direccion),
      direccion_correspondencia: sanitizeInput(
        formData.direccionCorrespondencia
      ),
      email: sanitizeInput(formData.email),
      numero_movil: sanitizeInput(formData.telefonos),
      id_tipo_documento: '8a49a2a6-8d0b-4fbe-b9c0-3c0c95f66efb',
      partida_electronica: sanitizeInput(formData.public_reg),
      fecha_fundacion: sanitizeInput(formData.anniversary_date || null),
      detalle_adicional: sanitizeInput(formData.description),
      sector_economico: sanitizeInput(formData.economic_section),
      ficha_asociado: nameFile,
      doc_dni: nameDniFile,
      pagina_web: sanitizeInput(formData.paginaWeb),
      documento: sanitizeInput(ruc),
    };

    try {
      const response = await axios.post(
        API_URL,
        {
          sanitized_data: sanitizedData,
          is_client: isClient,
          contactos_data: transformData(formData),
        },
        { headers: HEADERS }
      );

      if (response.data.error) {
        alert(response.data.error);
        return;
      }
    } catch (error) {
      console.error('Error en la petición:', error);
      alert('Error al subir el archivo.');
      setLoading(false);
    }

    try {
      const response = await axios.post(
        process.env.REACT_APP_FILE_URL,
        formDataToSend,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );

      if (response.data.error) {
        alert(response.data.error);
        setLoading(false);
      } else {
        alert('Las respuestas fueron ingresadas correctamente');
        setLoading(false);
        window.location.reload();
      }
    } catch (error) {
      console.error('Error al subir el archivo:', error);
      alert('Error al subir el archivo.');
      setLoading(false);
    }
  };

  // const formatNumber = (value) => {
  //   if (!value) return '';

  //   const [integerPart, decimalPart] = value.split('.');

  //   // Convertir la parte entera a número y luego formatear con toLocaleString
  //   const formattedInteger = integerPart
  //     ? Number(integerPart).toLocaleString('en-US')
  //     : '';

  //   return decimalPart !== undefined
  //     ? `${formattedInteger}.${decimalPart}`
  //     : formattedInteger;
  // };

  return (
    <>
      {loading && <Loading />}
      <Layout>
        <form>
          <h1 className='text-3xl font-bold text-[#058237] flex justify-center pb-5'>
            SOLICITUD DE AFILIACIÓN DE ASOCIADOS
          </h1>
          <p className='text-xs font-bold pt-2 pb-8 text-[#058237]'>
            ⚠️ Antes de completar este formulario, por favor realiza la{' '}
            <strong>consulta del RUC</strong> para validar los datos de la
            empresa.
          </p>
          <div className='form-row'>
            <div className='field'>
              <label className='text-xs font-bold uppercase'>
                Nº Partida Electrónica Reg. Públicos
                <div>
                  <input
                    type='text'
                    name='public_reg'
                    disabled={!searchRuc}
                    value={formData.public_reg}
                    onChange={handleChange}
                    style={{
                      border: '2px solid',
                      borderColor: errors.public_reg ? 'red' : 'transparent',
                    }}
                  />
                </div>
              </label>
            </div>

            <div className='field'>
              <label className='text-xs font-bold uppercase'>
                Aniversario de la empresa:
                <div>
                  <input
                    type='date'
                    name='anniversary_date'
                    disabled={!searchRuc}
                    value={formData.anniversary_date}
                    onChange={handleChange}
                  />
                </div>
              </label>
            </div>

            {/* <Dates
            name='anniversary_date'
            label='Aniversario de la empresa:'
            formData={formData}
            setFormData={setFormData}
            errors={errors}
          /> */}

            <div className='field'>
              <label className='text-xs font-bold uppercase'>
                RUC:
                <div>
                  <input
                    type='number'
                    name='ruc'
                    value={ruc}
                    onChange={handleRucChange}
                    required
                    style={{
                      border: '2px solid',
                      borderColor: errors.ruc ? 'red' : 'transparent',
                    }}
                  />
                </div>
              </label>
            </div>
            <div className='field'>
              <button
                className='bg-[#058237] hover:bg-green transition-colors duration-300 md:text-base cursor-pointer mt-7 text-white font-bold py-2 px-4 rounded-md w-[100%] text-sm'
                onClick={handleConsultarRuc}
                disabled={loading}
              >
                {loading ? 'Consultando...' : 'Consultar RUC'}
              </button>
            </div>
          </div>

          <div className='form-row'>
            <div className='big-field'>
              <label className='text-xs font-bold uppercase'>
                Razón social:
                <div>
                  <input
                    type='text'
                    name='razonSocial'
                    disabled={!searchRuc}
                    value={formData.razonSocial}
                    onChange={handleChange}
                    required
                    style={{
                      border: '2px solid',
                      borderColor: errors.razonSocial ? 'red' : 'transparent',
                    }}
                  />
                </div>
              </label>
            </div>
            <div className='big-field'>
              <label className='text-xs font-bold uppercase'>
                Nombre Comercial:
                <div>
                  <input
                    type='text'
                    name='nombreComercial'
                    disabled={!searchRuc}
                    value={formData.nombreComercial}
                    onChange={handleChange}
                    required
                    style={{
                      border: '2px solid',
                      borderColor: errors.nombreComercial
                        ? 'red'
                        : 'transparent',
                    }}
                  />
                </div>
              </label>
            </div>
          </div>

          <div className='form-row'>
            <div className='big-field'>
              <label className='text-xs font-bold uppercase'>
                Dirección:
                <div>
                  <input
                    type='text'
                    name='direccion'
                    disabled={!searchRuc}
                    value={formData.direccion}
                    onChange={handleChange}
                    required
                    style={{
                      border: '2px solid',
                      borderColor: errors.direccion ? 'red' : 'transparent',
                    }}
                  />
                </div>
              </label>
            </div>
            <div className='field'>
              <label className='text-xs font-bold uppercase'>
                Teléfonos:
                <div>
                  <input
                    type='number'
                    name='telefonos'
                    disabled={!searchRuc}
                    value={formData.telefonos}
                    onChange={handleChange}
                    required
                    style={{
                      border: '2px solid',
                      borderColor: errors.telefonos ? 'red' : 'transparent',
                    }}
                  />
                </div>
              </label>
            </div>
            <div className='medium-field'>
              <label className='text-xs font-bold uppercase'>
                Página web:
                <div>
                  <input
                    type='text'
                    name='paginaWeb'
                    disabled={!searchRuc}
                    value={formData.paginaWeb}
                    onChange={handleChange}
                  />
                </div>
              </label>
            </div>
          </div>

          <div className='form-row'>
            <div className='medium-field'>
              <label className='text-xs font-bold uppercase'>
                Email (para facturación electrónica):
                <div>
                  <input
                    type='text'
                    name='email'
                    disabled={!searchRuc}
                    value={formData.email}
                    onChange={handleChange}
                    onKeyDown={(e) => {
                      const allowedKeys = [
                        '@',
                        '-',
                        '_',
                        '.',
                        'Backspace',
                        'Delete',
                        'ArrowLeft',
                        'ArrowRight',
                        'Tab',
                      ];
                      const isLetter =
                        (e.key >= 'a' && e.key <= 'z') ||
                        (e.key >= 'A' && e.key <= 'Z');
                      const isNumber = e.key >= '0' && e.key <= '9';
                      if (
                        !allowedKeys.includes(e.key) &&
                        !isLetter &&
                        !isNumber
                      ) {
                        e.preventDefault();
                      }
                    }}
                    required
                    style={{
                      border: '2px solid',
                      borderColor: errors.email ? 'red' : 'transparent',
                    }}
                  />
                  {errors.email === 'Formato inválido' && (
                    <span style={{ color: 'red', fontSize: '12px' }}>
                      El email debe tener un formato válido (ej.
                      nombre@correo.com)
                    </span>
                  )}
                </div>
              </label>
            </div>
            <div className='big-field'>
              <label className='text-xs font-bold uppercase'>
                Dirección de correspondencia:
                <div>
                  <input
                    type='text'
                    name='direccionCorrespondencia'
                    disabled={!searchRuc}
                    value={formData.direccionCorrespondencia}
                    onChange={handleChange}
                    required
                    style={{
                      border: '2px solid',
                      borderColor: errors.direccionCorrespondencia
                        ? 'red'
                        : 'transparent',
                    }}
                  />
                </div>
              </label>
            </div>
          </div>

          <p className='md:text-3xl font-bold text-[#058237] flex text-xl pt-10 pl-0 pb-8'>
            PRINCIPALES EJECUTIVOS
          </p>

          <p className='md:text-xl font-bold text-[#058237] flex text-xl pl-0 pb-2'>
            CONTACTO PARA WHATSAPP
          </p>

          <div className='form-row'>
            <div className='medium-field'>
              <label className='text-xs font-bold uppercase'>
                Apellidos:
                <div>
                  <input
                    type='text'
                    name='last_name_1'
                    disabled={!searchRuc}
                    value={formData.last_name_1}
                    onChange={handleChange}
                    required
                    style={{
                      border: '2px solid',
                      borderColor: errors.last_name_1 ? 'red' : 'transparent',
                    }}
                  />
                </div>
              </label>
            </div>
            <div className='medium-field'>
              <label className='text-xs font-bold uppercase'>
                Nombres:
                <div>
                  <input
                    type='text'
                    name='names_1'
                    disabled={!searchRuc}
                    value={formData.names_1}
                    onChange={handleChange}
                    required
                    style={{
                      border: '2px solid',
                      borderColor: errors.names_1 ? 'red' : 'transparent',
                    }}
                  />
                </div>
              </label>
            </div>
            <div className='medium-field'>
              <label className='text-xs font-bold uppercase'>
                Cargo:
                <div>
                  <select
                    name='charge_1'
                    disabled={!searchRuc}
                    value={formData.charge_1}
                    onChange={(e) => {
                      const value = e.target.value;
                      setFormData({
                        ...formData,
                        charge_1: value,
                        otherCharge_1:
                          value === 'otro' ? '' : formData.otherCharge_1,
                      });
                    }}
                    required
                    style={{
                      border: '2px solid',
                      borderColor: errors.charge_1 ? 'red' : 'transparent',
                    }}
                  >
                    <option value=''>SELECCIONE UN CARGO</option>
                    {cargos.map((cargo, index) => (
                      <option
                        key={index}
                        value={cargo}
                      >
                        {cargo}
                      </option>
                    ))}
                  </select>
                </div>
              </label>
            </div>
          </div>

          <div className='form-row'>
            {formData.charge_1 === 'OTRO' && (
              <div className='medium-field'>
                <label className='text-xs font-bold uppercase'>
                  Ingrese su cargo:
                  <div>
                    <input
                      type='text'
                      name='otherCharge_1'
                      disabled={!searchRuc}
                      value={formData.otherCharge_1}
                      onChange={handleChange}
                      required
                      style={{
                        border: '2px solid',
                        borderColor: errors.otherCharge_1
                          ? 'red'
                          : 'transparent',
                        width: '100%',
                        padding: '15px',
                        height: '50px',
                        backgroundColor: '#ebebeb',
                        borderRadius: '20px',
                        boxSizing: 'border-box',
                        color: 'black',
                      }}
                    />
                  </div>
                </label>
              </div>
            )}
            <div className='medium-field'>
              <label className='text-xs font-bold uppercase'>
                Email:
                <div>
                  <input
                    type='text'
                    name='email_1'
                    disabled={!searchRuc}
                    value={formData.email_1}
                    onChange={handleChange}
                    onKeyDown={(e) => {
                      const allowedKeys = [
                        '@',
                        '-',
                        '_',
                        '.',
                        'Backspace',
                        'Delete',
                        'ArrowLeft',
                        'ArrowRight',
                        'Tab',
                      ];
                      const isLetter =
                        (e.key >= 'a' && e.key <= 'z') ||
                        (e.key >= 'A' && e.key <= 'Z');
                      const isNumber = e.key >= '0' && e.key <= '9';
                      if (
                        !allowedKeys.includes(e.key) &&
                        !isLetter &&
                        !isNumber
                      ) {
                        e.preventDefault();
                      }
                    }}
                    required
                    style={{
                      border: '2px solid',
                      borderColor: errors.email_1 ? 'red' : 'transparent',
                    }}
                  />
                  {errors.email_1 === 'Formato inválido' && (
                    <span style={{ color: 'red', fontSize: '12px' }}>
                      El email debe tener un formato válido (ej.
                      nombre@correo.com)
                    </span>
                  )}
                </div>
              </label>
            </div>
            <Dates
              name='birthday_1'
              label='Onomástico:'
              formData={formData}
              setFormData={setFormData}
            />
            <div className='field'>
              <label className='text-xs font-bold uppercase'>
                Teléfono:
                <div>
                  <input
                    type='number'
                    name='phone_1'
                    disabled={!searchRuc}
                    value={formData.phone_1}
                    onChange={handleChange}
                    required
                    style={{
                      border: '2px solid',
                      borderColor: errors.phone_1 ? 'red' : 'transparent',
                    }}
                  />
                </div>
              </label>
            </div>

            <div className='big_field justify-center items-center flex flex-col pt-4'>
              <label className='text-xs font-bold flex uppercase gap-2'>
                <input
                  type='checkbox'
                  name='representative_1'
                  disabled={!searchRuc}
                  checked={formData.representative_1}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      representative_1: e.target.checked,
                    })
                  }
                  className='w-4 h-4'
                />
                Representante legal
              </label>
            </div>
          </div>

          <p className='md:text-xl font-bold text-[#058237] flex text-xl pt-10 pl-0 pb-2'>
            CONTACTOS
          </p>
          <p className='text-xs font-bold pt-2 pb-4 text-[#058237] max-w-2xl'>
            *Por favor, no repitas contactos que ya hayan sido agregados
            previamente en la sección de WhatsApp. Esto nos ayuda a evitar
            duplicidades y mantener la información organizada.
          </p>

          <div className='form-row'>
            <div className='medium-field'>
              <label className='text-xs font-bold uppercase'>
                Apellidos (Ejecutivo #1):
                <div>
                  <input
                    required
                    style={{
                      border: '2px solid',
                      borderColor: errors.names_1 ? 'red' : 'transparent',
                    }}
                    type='text'
                    name='last_name_2'
                    disabled={!searchRuc}
                    value={formData.last_name_2}
                    onChange={handleChange}
                  />
                </div>
              </label>
            </div>

            <div className='medium-field'>
              <label className='text-xs font-bold uppercase'>
                Nombres (Ejecutivo #1):
                <div>
                  <input
                    required
                    style={{
                      border: '2px solid',
                      borderColor: errors.names_1 ? 'red' : 'transparent',
                    }}
                    type='text'
                    name='names_2'
                    disabled={!searchRuc}
                    value={formData.names_2}
                    onChange={handleChange}
                  />
                </div>
              </label>
            </div>
            <div className='medium-field'>
              <label className='text-xs font-bold uppercase'>
                Cargo (Ejecutivo #1):
                <div>
                  <select
                    name='charge_2'
                    disabled={!searchRuc}
                    value={formData.charge_2}
                    onChange={(e) => {
                      const value = e.target.value;
                      setFormData({
                        ...formData,
                        charge_2: value,
                        otherCharge_2:
                          value === 'otro' ? '' : formData.otherCharge_2,
                      });
                    }}
                    required
                    style={{
                      border: '2px solid',
                      borderColor: errors.charge_2 ? 'red' : 'transparent',
                      width: '100%',
                      padding: '15px',
                      height: '50px',
                      backgroundColor: '#ebebeb',
                      borderRadius: '20px',
                      boxSizing: 'border-box',
                      color: 'black',
                    }}
                  >
                    <option value=''>SELECCIONE UN CARGO</option>
                    {cargos.map((cargo, index) => (
                      <option
                        key={index}
                        value={cargo}
                      >
                        {cargo}
                      </option>
                    ))}
                  </select>
                </div>
              </label>
            </div>
          </div>

          <div className='form-row'>
            {formData.charge_2 === 'OTRO' && (
              <div className='medium-field'>
                <label className='text-xs font-bold uppercase'>
                  Ingrese su cargo:
                  <div>
                    <input
                      type='text'
                      name='otherCharge_2'
                      disabled={!searchRuc}
                      value={formData.otherCharge_2}
                      onChange={handleChange}
                      required
                      style={{
                        border: '2px solid',
                        borderColor: errors.otherCharge_2
                          ? 'red'
                          : 'transparent',
                        width: '100%',
                        padding: '15px',
                        height: '50px',
                        backgroundColor: '#ebebeb',
                        borderRadius: '20px',
                        boxSizing: 'border-box',
                        color: 'black',
                      }}
                    />
                  </div>
                </label>
              </div>
            )}
            <div className='medium-field'>
              <label className='text-xs font-bold uppercase'>
                Email (Ejecutivo #1):
                <div>
                  <input
                    required
                    style={{
                      border: '2px solid',
                      borderColor: errors.names_1 ? 'red' : 'transparent',
                    }}
                    type='text'
                    name='email_2'
                    disabled={!searchRuc}
                    value={formData.email_2}
                    onChange={handleChange}
                    onKeyDown={(e) => {
                      const allowedKeys = [
                        '@',
                        '-',
                        '_',
                        '.',
                        'Backspace',
                        'Delete',
                        'ArrowLeft',
                        'ArrowRight',
                        'Tab',
                      ];
                      const isLetter =
                        (e.key >= 'a' && e.key <= 'z') ||
                        (e.key >= 'A' && e.key <= 'Z');
                      const isNumber = e.key >= '0' && e.key <= '9';
                      if (
                        !allowedKeys.includes(e.key) &&
                        !isLetter &&
                        !isNumber
                      ) {
                        e.preventDefault();
                      }
                    }}
                  />
                  {errors.email_2 === 'Formato inválido' && (
                    <span style={{ color: 'red', fontSize: '12px' }}>
                      El email debe tener un formato válido (ej.
                      nombre@correo.com)
                    </span>
                  )}
                </div>
              </label>
            </div>
            <Dates
              name='birthday_2'
              label='Onomástico:'
              formData={formData}
              setFormData={setFormData}
            />
            <div className='field'>
              <label className='text-xs font-bold uppercase'>
                Teléfono (Ejecutivo #1):
                <div>
                  <input
                    type='number'
                    name='phone_2'
                    disabled={!searchRuc}
                    value={formData.phone_2}
                    onChange={handleChange}
                  />
                </div>
              </label>
            </div>
            <div className='big_field justify-center items-center flex flex-col pt-4'>
              <label className='text-xs font-bold flex uppercase gap-2'>
                <input
                  type='checkbox'
                  name='representative_2'
                  disabled={!searchRuc}
                  checked={formData.representative_2}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      representative_2: e.target.checked,
                    })
                  }
                  className='w-4 h-4'
                />
                Representante legal
              </label>
            </div>
          </div>

          <div className='form-row mt-10'>
            <div className='medium-field'>
              <label className='text-xs font-bold uppercase'>
                Apellidos (Ejecutivo #2):
                <div>
                  <input
                    type='text'
                    name='last_name_3'
                    disabled={!searchRuc}
                    value={formData.last_name_3}
                    onChange={handleChange}
                  />
                </div>
              </label>
            </div>
            <div className='medium-field'>
              <label className='text-xs font-bold uppercase'>
                Nombres (Ejecutivo #2):
                <div>
                  <input
                    type='text'
                    name='names_3'
                    disabled={!searchRuc}
                    value={formData.names_3}
                    onChange={handleChange}
                  />
                </div>
              </label>
            </div>
            <div className='medium-field'>
              <label className='text-xs font-bold uppercase'>
                Cargo (Ejecutivo #2):
                <div>
                  <select
                    name='charge_3'
                    disabled={!searchRuc}
                    value={formData.charge_3}
                    onChange={(e) => {
                      const value = e.target.value;
                      setFormData({
                        ...formData,
                        charge_3: value,
                        otherCharge_3:
                          value === 'otro' ? '' : formData.otherCharge_3,
                      });
                    }}
                  >
                    <option value=''>SELECCIONE UN CARGO</option>
                    {cargos.map((cargo, index) => (
                      <option
                        key={index}
                        value={cargo}
                      >
                        {cargo}
                      </option>
                    ))}
                  </select>
                </div>
              </label>
            </div>
          </div>
          <div className='form-row'>
            {formData.charge_3 === 'OTRO' && (
              <div className='medium-field'>
                <label className='text-xs font-bold uppercase'>
                  Ingrese su cargo:
                  <div>
                    <input
                      type='text'
                      name='otherCharge_3'
                      disabled={!searchRuc}
                      value={formData.otherCharge_3}
                      onChange={handleChange}
                      required
                      style={{
                        border: '2px solid',
                        borderColor: errors.otherCharge_3
                          ? 'red'
                          : 'transparent',
                        width: '100%',
                        padding: '15px',
                        height: '50px',
                        backgroundColor: '#ebebeb',
                        borderRadius: '20px',
                        boxSizing: 'border-box',
                        color: 'black',
                      }}
                    />
                  </div>
                </label>
              </div>
            )}
            <div className='medium-field'>
              <label className='text-xs font-bold uppercase'>
                Email (Ejecutivo #2):
                <div>
                  <input
                    type='text'
                    name='email_3'
                    disabled={!searchRuc}
                    value={formData.email_3}
                    onChange={handleChange}
                    onKeyDown={(e) => {
                      const allowedKeys = [
                        '@',
                        '-',
                        '_',
                        '.',
                        'Backspace',
                        'Delete',
                        'ArrowLeft',
                        'ArrowRight',
                        'Tab',
                      ];
                      const isLetter =
                        (e.key >= 'a' && e.key <= 'z') ||
                        (e.key >= 'A' && e.key <= 'Z');
                      const isNumber = e.key >= '0' && e.key <= '9';
                      if (
                        !allowedKeys.includes(e.key) &&
                        !isLetter &&
                        !isNumber
                      ) {
                        e.preventDefault();
                      }
                    }}
                  />
                  {errors.email_3 === 'Formato inválido' && (
                    <span style={{ color: 'red', fontSize: '12px' }}>
                      El email debe tener un formato válido (ej.
                      nombre@correo.com)
                    </span>
                  )}
                </div>
              </label>
            </div>
            <Dates
              name='birthday_3'
              label='Onomástico:'
              formData={formData}
              setFormData={setFormData}
            />

            <div className='field'>
              <label className='text-xs font-bold uppercase'>
                Teléfono (Ejecutivo #2):
                <div>
                  <input
                    type='number'
                    name='phone_3'
                    disabled={!searchRuc}
                    value={formData.phone_3}
                    onChange={handleChange}
                  />
                </div>
              </label>
            </div>
            <div className='big_field justify-center items-center flex flex-col pt-4'>
              <label className='text-xs font-bold flex uppercase gap-2'>
                <input
                  type='checkbox'
                  name='representative_3'
                  disabled={!searchRuc}
                  checked={formData.representative_3}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      representative_3: e.target.checked,
                    })
                  }
                  className='w-4 h-4'
                />
                Representante legal
              </label>
            </div>
          </div>

          <div className='form-row mt-10'>
            <div className='medium-field'>
              <label className='text-xs font-bold uppercase'>
                Apellidos (Ejecutivo #3):
                <div>
                  <input
                    type='text'
                    name='last_name_4'
                    disabled={!searchRuc}
                    value={formData.last_name_4}
                    onChange={handleChange}
                  />
                </div>
              </label>
            </div>
            <div className='medium-field'>
              <label className='text-xs font-bold uppercase'>
                Nombres (Ejecutivo #3):
                <div>
                  <input
                    type='text'
                    name='names_4'
                    disabled={!searchRuc}
                    value={formData.names_4}
                    onChange={handleChange}
                  />
                </div>
              </label>
            </div>
            <div className='medium-field'>
              <label className='text-xs font-bold uppercase'>
                Cargo (Ejecutivo #3):
                <div>
                  <select
                    name='charge_4'
                    disabled={!searchRuc}
                    value={formData.charge_4}
                    onChange={(e) => {
                      const value = e.target.value;
                      setFormData({
                        ...formData,
                        charge_4: value,
                        otherCharge_4:
                          value === 'otro' ? '' : formData.otherCharge_4,
                      });
                    }}
                  >
                    <option value=''>SELECCIONE UN CARGO</option>
                    {cargos.map((cargo, index) => (
                      <option
                        key={index}
                        value={cargo}
                      >
                        {cargo}
                      </option>
                    ))}
                  </select>
                </div>
              </label>
            </div>
          </div>
          <div className='form-row'>
            {formData.charge_4 === 'OTRO' && (
              <div className='medium-field'>
                <label className='text-xs font-bold uppercase'>
                  Ingrese su cargo:
                  <div>
                    <input
                      type='text'
                      name='otherCharge_4'
                      disabled={!searchRuc}
                      value={formData.otherCharge_4}
                      onChange={handleChange}
                      required
                      style={{
                        border: '2px solid',
                        borderColor: errors.otherCharge_4
                          ? 'red'
                          : 'transparent',
                        width: '100%',
                        padding: '15px',
                        height: '50px',
                        backgroundColor: '#ebebeb',
                        borderRadius: '20px',
                        boxSizing: 'border-box',
                        color: 'black',
                      }}
                    />
                  </div>
                </label>
              </div>
            )}
            <div className='medium-field'>
              <label className='text-xs font-bold uppercase'>
                Email (Ejecutivo #3):
                <div>
                  <input
                    type='text'
                    name='email_4'
                    disabled={!searchRuc}
                    value={formData.email_4}
                    onChange={handleChange}
                    onKeyDown={(e) => {
                      const allowedKeys = [
                        '@',
                        '-',
                        '_',
                        '.',
                        'Backspace',
                        'Delete',
                        'ArrowLeft',
                        'ArrowRight',
                        'Tab',
                      ];
                      const isLetter =
                        (e.key >= 'a' && e.key <= 'z') ||
                        (e.key >= 'A' && e.key <= 'Z');
                      const isNumber = e.key >= '0' && e.key <= '9';
                      if (
                        !allowedKeys.includes(e.key) &&
                        !isLetter &&
                        !isNumber
                      ) {
                        e.preventDefault();
                      }
                    }}
                  />
                  {errors.email_4 === 'Formato inválido' && (
                    <span style={{ color: 'red', fontSize: '12px' }}>
                      El email debe tener un formato válido (ej.
                      nombre@correo.com)
                    </span>
                  )}
                </div>
              </label>
            </div>
            <Dates
              name='birthday_4'
              label='Onomástico:'
              formData={formData}
              setFormData={setFormData}
            />
            <div className='field'>
              <label className='text-xs font-bold uppercase'>
                Teléfono (Ejecutivo #3):
                <div>
                  <input
                    type='number'
                    name='phone_4'
                    disabled={!searchRuc}
                    value={formData.phone_4}
                    onChange={handleChange}
                  />
                </div>
              </label>
            </div>
            <div className='big_field justify-center items-center flex flex-col pt-4'>
              <label className='text-xs font-bold flex uppercase gap-2'>
                <input
                  type='checkbox'
                  name='representative_4'
                  disabled={!searchRuc}
                  checked={formData.representative_4}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      representative_4: e.target.checked,
                    })
                  }
                  className='w-4 h-4'
                />
                Representante legal
              </label>
            </div>
          </div>

          <p className='md:text-3xl font-bold text-[#058237] flex text-xl pt-10 pl-0 pb-8'>
            SECTOR ECONÓMICO AL QUE PERTENECE SU ACTIVIDAD
          </p>

          <div className='form-row'>
            <div className='medium-field'>
              <label className='text-xs font-bold uppercase'>
                Sector Económico:
                <div>
                  <textarea
                    name='economic_section'
                    value={formData.economic_section}
                    onChange={handleChange}
                    disabled={!searchRuc}
                    rows={1}
                    required
                    style={{
                      width: '100%',
                      padding: '15px',
                      backgroundColor: '#ebebeb',
                      borderRadius: '10px',
                      boxSizing: 'border-box',
                      color: 'black',
                      border: '2px solid',
                      borderColor: errors.economic_section
                        ? 'red'
                        : 'transparent',
                    }}
                  />
                </div>
              </label>
            </div>
          </div>

          <div className='form-row'>
            <div className='big-field'>
              <label className='text-xs font-bold uppercase'>
                Háganos una breve descripción de la actividad que realiza su
                empresa (Máximo 20 palabras):
              </label>
              <p className='text-xs font-bold pt-2 text-[#058237]'>
                *Información requerida para la descripción de su empresa para
                nuestra página web, directorio empresarial y revista
                institucional
              </p>
              <div>
                <textarea
                  name='description'
                  value={formData.description}
                  disabled={!searchRuc}
                  onChange={handleChange}
                  required
                  style={{
                    width: '100%',
                    padding: '15px',
                    height: '100px',
                    backgroundColor: '#ebebeb',
                    borderRadius: '10px',
                    boxSizing: 'border-box',
                    color: 'black',
                    border: '2px solid',
                    borderColor: errors.description ? 'red' : 'transparent',
                  }}
                />
                {formData.description
                  .trim()
                  .split(/\s+/)
                  .filter((w) => w).length === 20 && (
                  <p className='text-yellow-600 text-xs mt-1'>
                    Límite máximo de 20 palabras alcanzado.
                  </p>
                )}
              </div>
            </div>
          </div>

          <p className='md:text-3xl font-bold text-[#058237] flex text-xl pt-10 pl-0 pb-8'>
            INFORMACIÓN COMPLEMENTARIA (SOLO PARA USO INTERNO)
          </p>

          <div className='form-row'>
            <div className='field'>
              <label className='text-xs font-bold uppercase'>
                N° de empleados:
                <div>
                  <input
                    type='number'
                    name='number_employees'
                    disabled={!searchRuc}
                    value={formData.number_employees}
                    onChange={handleChange}
                    onWheel={(e) => e.target.blur()}
                    onFocus={(e) => e.target.select()}
                    min={0}
                    style={{
                      border: '2px solid',
                      borderColor: errors.number_employees
                        ? 'red'
                        : 'transparent',
                    }}
                  />
                </div>
              </label>
            </div>
            <div className='field'>
              <label className='text-xs font-bold uppercase'>
                Patrimonio (en Soles):
                <div>
                  <input
                    ref={inputRef}
                    type='text'
                    name='heritage'
                    disabled={!searchRuc}
                    value={formData.heritage}
                    onChange={handleChange}
                    onWheel={(e) => e.target.blur()}
                    min={0}
                    onFocus={(e) => e.target.select()}
                    style={{
                      border: '2px solid',
                      borderColor: errors.heritage ? 'red' : 'transparent',
                    }}
                  />
                </div>
              </label>
            </div>
            <div className='field'>
              <label className='text-xs font-bold uppercase'>
                Venta Anual (en Soles):
                <div>
                  <input
                    ref={inputRef}
                    type='text'
                    name='anual_sale'
                    disabled={!searchRuc}
                    value={formData.anual_sale}
                    onWheel={(e) => e.target.blur()}
                    onChange={handleChange}
                    min={0}
                    onFocus={(e) => e.target.select()}
                    style={{
                      border: '2px solid',
                      borderColor: errors.anual_sale ? 'red' : 'transparent',
                    }}
                  />
                </div>
              </label>
            </div>
          </div>

          <p className='md:text-3xl font-bold text-[#058237] flex text-xl pt-10 pl-0 pb-8'>
            AUTORIZACIÓN
          </p>

          <div className='form-row'>
            <div className='medium-field'>
              <label className='text-xs font-bold uppercase'>
                Persona que autoriza la afiliación:
                <div>
                  <input
                    type='text'
                    name='authorization_person'
                    disabled={!searchRuc}
                    value={formData.authorization_person}
                    onChange={handleChange}
                    required
                    style={{
                      border: '2px solid',
                      borderColor: errors.authorization_person
                        ? 'red'
                        : 'transparent',
                    }}
                  />
                </div>
              </label>
            </div>
            <div className='medium-field'>
              <label className='text-xs font-bold uppercase'>
                Cargo de la persona que autoriza la afiliación:
                <div>
                  <input
                    type='text'
                    name='authorization_person_charge'
                    disabled={!searchRuc}
                    value={formData.authorization_person_charge}
                    onChange={handleChange}
                    required
                    style={{
                      border: '2px solid',
                      borderColor: errors.authorization_person_charge
                        ? 'red'
                        : 'transparent',
                    }}
                  />
                </div>
              </label>
            </div>
          </div>

          <div className='form-row'>
            <button
              onClick={handleDownload}
              disabled={loading}
              className='bg-[#058237] hover:bg-green transition-colors 
                        cursor-pointer mt-7 text-white font-bold 
                        py-2 px-4 rounded-md w-[100%] text-sm md:w-[20%]'
              type='button'
            >
              {loading ? 'Generando PDF...' : 'Descargar Solicitud'}
            </button>
          </div>

          {uploadDocument && (
            <div className='success-dialog'>
              <p>
                Una vez generada su solicitud:
                <br /> 1. Imprima el archivo PDF generado
                <br /> 2. Firme la solicitud con el sello de su empresa
                <br /> 3. Escanee la solicitud completa
                <br /> 4. Cargue la foto o archivo haciendo "click" en Examinar
                <br /> 5. Asimismo, cargue la foto o archivo de su DNI escaneado
                <br /> 6. Haga "click" en Enviar
              </p>

              <div className='form-row mt-10'>
                <label className='text-xs font-bold uppercase'>
                  Adjuntar PDF:
                  <input
                    type='file'
                    accept='.pdf'
                    onChange={handleFileChange}
                    className='mt-2'
                  />
                </label>
                {preview && preview !== 'non-image' && (
                  <img
                    src={preview}
                    alt='Vista previa de la imagen'
                    className='mt-2 preview'
                  />
                )}
                {preview === 'non-image' && fileUpload && (
                  <p className='text-green-600 text-sm mt-2 font-semibold'>
                    ✅ Ficha cargada correctamente: {fileUpload.name}
                  </p>
                )}
              </div>
              {uploadDocument && (
                <div className='success-dialog'>
                  <div className='form-row'>
                    <label className='text-xs font-bold uppercase'>
                      Adjuntar DNI escaneado (formato PDF):
                      <input
                        type='file'
                        accept='.pdf'
                        onChange={handleDniChange}
                        className='mt-2'
                      />
                    </label>
                    {previewDni && previewDni !== 'non-image' && (
                      <img
                        src={previewDni}
                        alt='Vista previa de DNI'
                        className='mt-2 preview'
                      />
                    )}

                    {previewDni === 'non-image' && dnifile && (
                      <p className='text-green-600 text-sm mt-2 font-semibold'>
                        ✅ Archivo DNI cargado correctamente: {dnifile.name}
                      </p>
                    )}
                  </div>
                </div>
              )}

              <div className='form-row'>
                <button
                  onClick={handleSubmit}
                  disabled={loading}
                  className='bg-[#058237] hover:bg-green transition-colors 
                                cursor-pointer mt-7 text-white font-bold 
                                py-2 px-4 rounded-md w-[100%] text-sm md:w-[20%]'
                  type='button'
                >
                  Enviar
                </button>
              </div>
            </div>
          )}
        </form>
      </Layout>
    </>
  );
};

export default Forms;
